import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import TopNavigation from '@/components/common/layout/TopNavigation';
import { DashboardPageContent, SUPERADMIN_ONLY_SUBMENUS } from './DashboardPageContent';
import { getMenuFromPath } from '@/config/routes';

/**
 * URL 기반 콘텐츠 페이지
 * - URL 경로에 따라 적절한 콘텐츠 렌더링
 * - TopNavigation 포함
 */
const ContentPage: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();

  // URL에서 메뉴 정보 추출
  const menuInfo = getMenuFromPath(location.pathname);
  const activeSubMenu = menuInfo?.subMenuId || 'service-usage';

  if (!user) {
    return null;
  }

  // 슈퍼관리자 전용 페이지인지 확인
  const isSuperAdminPage = user.role === 'saas_admin' && SUPERADMIN_ONLY_SUBMENUS.includes(activeSubMenu);

  return (
    <>
      {/* 상단 네비게이션 */}
      <TopNavigation />

      {/* 콘텐츠 */}
      <div className={isSuperAdminPage ? 'superadmin-page-bg min-h-screen' : ''}>
        <main className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <DashboardPageContent user={user} activeSubMenu={activeSubMenu} />
        </main>
      </div>
    </>
  );
};

export default ContentPage;
